const Backbone = require('lib/backbone')
const _ = require('lib/underscore')
const $ = require('lib/jquery')
const BaseModel = require('lib/base_model')
const log = require('log').create('related_list') // eslint-disable-line

const RelatedList = Backbone.Collection.extend({

    url() {
        // related list must have an id and a parent in order to form a url
        if (! this.id) return
        const base = _.result(this.parents && this.parents[0], 'url')
        if (! base) return
        return base.replace(/([^\/])$/, '$1/') + encodeURIComponent(this.id)
    },

    model: BaseModel,

    update(models) {
        if (! _.isEqual(this.toJSON(), models)) {
            this.reset(models)
            this.trigger('change')
            return this.save()
        }

        const deferred = $.Deferred()
        deferred.resolve()
        return deferred.promise()
    },

    save(options) {
        // save the whole collection
        // expects an array of models to be returned
        // resets itself with the return
        const xhr = Backbone.sync.apply(this, ['update', this, options])
        xhr.done(_.bind(this.reset, this))
        return xhr
    },

})

module.exports = RelatedList
